import React from 'react';
import ReactDOM from 'react-dom';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

require('./css/bootstrap.min.css');
require('./css/material-icons.css');
require('./css/font-awesome.min.css');
require('./css/react-select.css');
require('./css/quill.snow.css');
require('react-image-crop/dist/ReactCrop.css');
require('react-datetime/css/react-datetime.css');

require('./css/base.css');

import './config';
import './translations';

import Storage from './Storage.js';
import AdminPanel from './AdminPanel';

dayjs.extend(customParseFormat);

//console.log(process.env.NODE_ENV)
//"development" "production"
Storage.setLanguage(process.env.REACT_APP_LANG || "en");

ReactDOM.render(
  <AdminPanel/>,
  document.getElementById('content')
);



// WEBPACK FOOTER //
// ./src/index.js